import React from 'react'

export type FieldLabelProps = React.ComponentProps<'label'>

export const FieldLabel: React.FC<FieldLabelProps> = React.memo(({ children, ...props }) => (
  <label {...props}>{children}</label>
))
